module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "links"
  }, [_c('span', {
    staticClass: "callToAction"
  }, [_vm._v(_vm._s(_vm.t('Contact us')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "phoneBlock"
  }, [_c('button', {
    staticClass: "toggleButton btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.toggleContact('phone')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })]), _c('i', {
    staticClass: "icon fa fa-phone"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPhone),
      expression: "showPhone"
    }],
    staticClass: "phone"
  }, [_vm._v("+351 936 326 295")])]), _vm._v(" "), _c('span', {
    staticClass: "emailBlock"
  }, [_c('button', {
    staticClass: "toggleButton btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.toggleContact('email')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _c('i', {
    staticClass: "icon fa fa-envelope"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEmail),
      expression: "showEmail"
    }],
    staticClass: "email"
  }, [_vm._v("info@booknatura.com")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d05c0c8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d05c0c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/ContactUsLinks.vue
// module id = 776
// module chunks = 3